<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    onClick: () => void;
    disabled?: boolean;
    children: Snippet;
  };
  const props: Props = $props();
</script>

<button disabled={props.disabled} class="nav-button" onclick={props.onClick}>
  {@render props.children()}
</button>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';
  @use '~/theme/include-media' as *;

  .nav-button {
    transition: background-color 0.2s ease;
    cursor: pointer;
    border-radius: 999px;
    position: absolute;
    background: none;
    border: none;
    margin-top: -0.5em;
    margin-right: -0.5em;
    margin-bottom: 0;
    text-decoration: underline;
    display: flex;
    align-items: end;
    flex-direction: column;
    top: 0;
    right: 0;
    color: black;
    &:disabled {
      text-decoration: none;
      &:active,
      &:hover {
        background-color: none;
      }
    }
    :global(html.dark-mode) & {
      color: white;
    }
    &:active {
      background-color: color.adjust(
        theme.$tile-default-light,
        $lightness: -20%
      );
      :global(html.dark-mode) & {
        background-color: color.adjust(
          theme.$tile-default-dark,
          $lightness: 20%
        );
      }
    }
    &:hover {
      background-color: color.adjust(
        theme.$tile-default-light,
        $lightness: -10%
      );
      :global(html.dark-mode) & {
        background-color: color.adjust(
          theme.$tile-default-dark,
          $lightness: 10%
        );
      }
    }
  }
</style>
